(function () {
  // Nique regional size display.
  // Womens variant option values carry both regions ("AU 10 / US 6"); this
  // script shows only the active region, keeping its code so the number is
  // never ambiguous: USD -> "US 6", any other currency -> "AU 10". The space
  // is deliberate — Aur Ocea renders "AU6", Nique reads better spaced, and
  // the Magic Fit SDK matches this form so its recommendation reads the same
  // as the swatch beside it.
  // Text without the combined format (letter sizes, waist sizes, colours,
  // bare numerics pre-rename) is never modified, and <input> values are never
  // touched — the cart always receives the real combined variant value.
  // Currency changes reload the page (Shopify localization form), so the
  // region is read fresh on each pass.
  // Two regexes, deliberately: the non-global one is safe to .test() (a /g
  // regex carries lastIndex between calls and would skip every other element),
  // the global one rewrites every pair in a string. String.replace resets
  // lastIndex itself, so the global one is safe to reuse.
  // Either separator: the option values read "AU 8 / US 4" today, but Shopify
  // itself joins a line item's options with " / " ("BLACK / AU 8 / US 4" at
  // checkout), so the pipe form "AU 8 | US 4" is the clearer one to rename to.
  // Matching both means the storefront keeps collapsing to one region either
  // side of that rename, with no flag day.
  var COMBINED_RE = /AU\s*(\d+)\s*[\/|]\s*US\s*(\d+)/;
  var COMBINED_RE_ALL = /AU\s*(\d+)\s*[\/|]\s*US\s*(\d+)/g;
  var TARGET_SELECTOR = [
    'label.SizeSwatch',
    'label.SizeSwatchNoPre', // preorder form: sold-out sizes
    '.ProductForm__SelectedValue',
    '.Popover__Value', // dropdown selector_mode (theme default for new blocks)
    '.VariantSelector__ChoiceValue',
    '.CartItem__Variant',
    // Collection-card quick add. Both spellings are the same element: the
    // colour+size branch of product-item.liquid emits .Swatch and the
    // size-only branch .swatch (ad-landing-page*.liquid mirror both). The
    // labels sit in a 40px rotated column, so a combined value wrapped onto
    // two lines and the overflow collided with the size below it. Class
    // names are case-sensitive in a selector, hence the pair; both are
    // unique to quick add across the theme. Only the text is rewritten —
    // the add-to-cart handler in custom.js.liquid reads data-variant-id.
    '.Swatch',
    '.swatch'
  ].join(', ');
  var ORIGINAL_ATTR = 'data-original-size';

  // Every target is a leaf element rendering a bare option value, so assigning
  // textContent cannot destroy markup the theme depends on. The theme reads
  // selections from data-value / input.value (theme.js _valueChanged,
  // _onOptionChanged), never from the text we rewrite.
  function activeRegion() {
    try {
      var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      if (currency === 'USD') return { code: 'US', useUs: true };
    } catch (_) {}
    return { code: 'AU', useUs: false };
  }

  function applyAll() {
    var region = activeRegion();
    var elements = document.querySelectorAll(TARGET_SELECTOR);
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      var text = el.textContent || '';
      if (!COMBINED_RE.test(text)) continue;
      var replaced = text.replace(COMBINED_RE_ALL, function (match, auSize, usSize) {
        return region.code + ' ' + (region.useUs ? usSize : auSize);
      });
      if (replaced === text) continue;
      // Set unconditionally: the theme rewrites .ProductForm__SelectedValue
      // with a fresh combined value on every variant change, and a stale
      // attribute is worse than none.
      el.setAttribute(ORIGINAL_ATTR, text.trim());
      el.textContent = replaced;
    }
  }

  function observe() {
    // Re-applies after theme re-renders: variant changes rewrite
    // .ProductForm__SelectedValue with the raw combined value (theme.js
    // _onOptionChanged), and the ajax cart re-renders .CartItem__Variant.
    // Our own rewrites can't loop: the replacement ("AU 6", min 4 chars) is
    // always strictly shorter than the shortest possible match ("AU1/US1" or
    // "AU1|US1", 7 chars), so text shrinks monotonically and passes always
    // terminate. The output also never re-matches: it carries one region code,
    // and the pattern needs an AU number and a US number either side of the
    // separator.
    // Attribute writes don't re-trigger us either — `attributes` defaults
    // to false in the observer options below.
    var observer = new MutationObserver(function () {
      applyAll();
    });
    try {
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    } catch (error) {
      try { console.error('Nique regional size display: observer failed', error); } catch (_) {}
    }
  }

  function initialise() {
    try {
      applyAll();
      observe();
    } catch (error) {
      try { console.error('Nique regional size display: failed to initialise', error); } catch (_) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();
